"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsRoleLabels = exports.AnalyticsRoles = void 0;

var _analyticsRoleLabels;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AnalyticsRoles;
exports.AnalyticsRoles = AnalyticsRoles;

(function (AnalyticsRoles) {
  AnalyticsRoles["NONE"] = "none";
  AnalyticsRoles["VIEW"] = "view";
})(AnalyticsRoles || (exports.AnalyticsRoles = AnalyticsRoles = {}));

var analyticsRoleLabels = (_analyticsRoleLabels = {}, _defineProperty(_analyticsRoleLabels, AnalyticsRoles.NONE, 'None'), _defineProperty(_analyticsRoleLabels, AnalyticsRoles.VIEW, 'Viewer'), _analyticsRoleLabels);
exports.analyticsRoleLabels = analyticsRoleLabels;